import { canHookSetupBeSkipped } from 'app/beta-editor/utils/NodeUtils';

import isValidAuth from 'app/beta-editor/utils/isValidAuth';
import isHookPollable from 'app/beta-editor/utils/isHookPollable';
import hasHookURL from 'app/beta-editor/utils/hasHookURL';
import { RequiredBehaviors } from 'app/beta-editor/pages/types';

const label = 'Set Up Webhook';
const webhookBehavior: RequiredBehaviors = {
  skipDuringWalkthrough({ flow, node, services, shouldUseSimpleZapSetup }) {
    // when hooks are pollable, show the webhook setup screen because the user
    // wont be shown hook setup directions on the first test directions screen.
    return shouldUseSimpleZapSetup
      ? !isHookPollable(node, services)
      : canHookSetupBeSkipped(flow, node);
  },

  label: () => label,

  menuLabel: () => label,

  crumbLabel: () => label,

  data() {
    return;
  },

  status() {
    return 'success';
  },

  visible({ flow, node, services }) {
    return Boolean(
      node.selected_api &&
        node.action &&
        hasHookURL(node, services) &&
        isValidAuth(node, services) &&
        !canHookSetupBeSkipped(flow, node)
    );
  },

  isClickable() {
    return true;
  },

  isLocked() {
    return false;
  },
};

export default webhookBehavior;
